<template>
  <div>
    <div>
      <Form ref="integralUnitForm" :label-width="180" :model="form" :rules="rules">
        <Spin size="large" fix v-if="loading"></Spin>
        <Row :gutter="16">
          <Col span="24">
          <FormItem label="是否有这些材料" prop="id">
            <Checkbox disabled v-model.trim="form.hasHRPermit" label="人力资源服务许可证">人力资源服务许可证</Checkbox>
            <Checkbox disabled v-model.trim="form.hasLaborDispatchPermit" label="劳务派遣经营许可证">劳务派遣经营许可证</Checkbox>
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="12">
          <FormItem label="人事专员介绍信" prop="personnelLetterGuid" :rules="{required: true, message:'请上传', trigger: 'blur'}">
            <Upload ref="personnelLetterGuid" :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :on-preview="handlePreview" :before-upload='(file)=>handleBefore("personnelLetterGuid")'
              :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'personnelLetterGuid')"
              :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid',false)" :on-format-error="handleFormatError">
              <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
              <Button icon="ios-camera" @click.stop="openQrCodeUpload('personnelLetterGuid',false)">手机拍照上传</Button>
            </Upload>
            <div class="_linkdel" v-for="file in form.personnelLetterGuidPreview" :key="file.guid">
              <div class="fileCentent" @click="handlePreview(file)">
                <Icon :type="file.name | fileType" />
                {{file.name}}
              </div>
              <div class="fileDel">
                <Icon type="md-close" @click="handleRemove(file, null, 'personnelLetterGuid')" />
              </div>
            </div>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="社会保险登记材料" prop="socialInsuranceRegGuidList" :rules="{required: true, message:'请上传', trigger: 'blur',type:'array'}">
            <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.socialInsuranceRegGuidListPreview" :on-preview="handlePreview" ref="socialInsuranceRegGuidList"
              :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `socialInsuranceRegGuidList`,true)"
              :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`socialInsuranceRegGuidList`,true)" :on-format-error="handleFormatError">
              <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
              <Button icon="ios-camera" @click.stop="openQrCodeUpload('socialInsuranceRegGuidList',false)">手机拍照上传</Button>
            </Upload>
            <div class="_linkdel" v-for="file in form.socialInsuranceRegGuidListPreview" :key="file.guid">
              <div class="fileCentent" @click="handlePreview(file)">
                <Icon :type="file.name | fileType" />
                {{file.name}}
              </div>
              <div class="fileDel">
                <Icon type="md-close" @click="handleRemove(file, null, `socialInsuranceRegGuidList`,true)" />
              </div>
            </div>
          </FormItem>
          </Col>
          <Col span="12" v-if="form.hasHRPermit===true">
          <FormItem label="人力资源服务许可证" prop="hrPermitGuid" :rules="{required: true, message:'请上传', trigger: 'blur'}">
            <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.hrPermitGuidList" :on-preview="handlePreview" ref="hrPermitGuid"
              :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `hrPermitGuid`)"
              :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`hrPermitGuid`)" :before-upload='(file)=>handleBefore(`hrPermitGuid`)' :on-format-error="handleFormatError">
              <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
              <Button icon="ios-camera" @click.stop="openQrCodeUpload('hrPermitGuid')">手机拍照上传</Button>
            </Upload>
            <div class="_linkdel" v-for="file in form.hrPermitGuidPreview" :key="file.guid">
              <div class="fileCentent" @click="handlePreview(file)">
                <Icon :type="file.name | fileType" />
                {{file.name}}
              </div>
              <div class="fileDel">
                <Icon type="md-close" @click="handleRemove(file, null, `hrPermitGuid`)" />
              </div>
            </div>
          </FormItem>
          </Col>
          <Col span="12" v-if="form.hasLaborDispatchPermit===true">
          <FormItem label="劳务派遣经营许可证" prop="laborDispatchPermitGuid" :rules="{required: true, message:'请上传', trigger: 'blur'}">
            <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.laborDispatchPermitGuidList" :on-preview="handlePreview" ref="laborDispatchPermitGuid"
              :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `laborDispatchPermitGuid`)"
              :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`laborDispatchPermitGuid`)" :before-upload='(file)=>handleBefore(`laborDispatchPermitGuid`)' :on-format-error="handleFormatError">
              <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
              <Button icon="ios-camera" @click.stop="openQrCodeUpload('laborDispatchPermitGuid')">手机拍照上传</Button>
            </Upload>
            <div class="_linkdel" v-for="file in form.laborDispatchPermitGuidPreview" :key="file.guid">
              <div class="fileCentent" @click="handlePreview(file)">
                <Icon :type="file.name | fileType" />
                {{file.name}}
              </div>
              <div class="fileDel">
                <Icon type="md-close" @click="handleRemove(file, null, `laborDispatchPermitGuid`)" />
              </div>
            </div>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="其他材料" prop="otherFileGuidList">
            <Upload ref="otherFileGuidList" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :show-upload-list="false" :default-file-list="form.otherFileGuidListPreview" style="flex:1;" :on-preview="handlePreview"
              :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'otherFileGuidList',true)"
              :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'otherFileGuidList',true)" :on-format-error="handleFormatError">
              <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
              <Button icon="ios-camera" @click.stop="openQrCodeUpload('otherFileGuidList',true)">手机拍照上传</Button>
            </Upload>
            <div class="_linkdel" v-for="file in form.otherFileGuidListPreview" :key="file.guid">
              <div class="fileCentent" @click="handlePreview(file)">
                <Icon :type="file.name | fileType" />
                {{file.name?file.name:file.fileName}}
              </div>
              <div class="fileDel">
                <Icon type="md-close" @click="handleRemove(file, null, 'otherFileGuidList',true)" />
              </div>
            </div>
          </FormItem>
          </Col>
        </Row>
        <div class="bom_btn">
          <div>
            <Button @click="next(null,0)">上一步</Button>
            <Button type="primary" @click="next('integralUnitForm')">提交</Button>
          </div>
        </div>
      </Form>
    </div>
  </div>

</template>
<script>
export default {
  props: { form: { type: Object } },
  data() {
    return {
      uploadData: {},
      isSubBtn: true, //不允许提交受理
      isKwd: false, //是否跨网点办理

      rules: {},
      clList: ['jsx', 'fmcl', 'yyzz', 'tgd', 'zmcl', 'jzzzfm', 'qt'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    next(name, val) {
      if (name) {
        this.$refs[name].validate(async (valid) => {
          if (!valid) {
            this.$Message.error('请将信息填写完整')
            return
          }
          // this.$emit('next', this.form.applicationType)
          //下一步

          //有提交路径才执行
          this.$Modal.confirm({
            title: '提示',
            content: '<p>确认提交申请？</p>',
            okText: '是',
            cancelText: '否',
            onOk: async () => {
              // 是 直接提交
              this.submitAccept()
            },
            onCancel: () => {},
          })

          //this.checkUserOpen()
        })
        return
      }
      this.$emit('next', val)
    },
    async submitAccept(name) {
      this.loading = true
      let params = {
        guid: '',
        enterpriseId: 0,
        enterpriseName: '',
        enterpriseCode: '',
        personnelId: 0,
        personnelName: '',
        personnelIDCardNo: '',
        personnelPhone: '',
        hasHRPermit: null,
        hasLaborDispatchPermit: null,
        personnelLetterGuid: '',
        laborDispatchPermitGuid: '',
        hrPermitGuid: '',
        socialInsuranceRegGuidList: [],
        otherFileGuidList: [],
      }
      for (let key in params) {
        if (key in this.form) {
          params[key] = this.form[key]
        }
      }
      try {
        let data = await this.$Ajax.post(
          '/api/services/app/OtherApplicationApi/SaveOpenAccountApplicationInfo',
          params
        )
        this.loading = false
        if (data.data.success) {
          this.$Message.success({
            content: '提交成功',
            background: true,
            duration: 6,
          })
        }

        this.$emit('setResult', data.data.result)
        this.next(null, 100)
      } catch (error) {
        this.loading = false
      }
    },
    //暂存
    async submitStore() {
      this.$emit('submit', `/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`, 0, '保存成功')
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
      this.$refs['integralUnitForm'].validateField(property)
    },
    resmove(name) {
      this.$refs[name].resetFields()
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      try {
        this.$refs[property].clearFiles()
      } catch (error) {}
    },
  },
}
</script>
<style lang="less" scoped>
.table,
.table > tr,
.table > tr > td,
.table > tr > th {
  border: solid 1px #eee;
  border-collapse: collapse;
  padding: 10px;
  text-align: left;
}

.table .des {
  font-size: 14px;
  color: #d4d4d4;
}

.table .ivu-form-item {
  margin-bottom: 5px;
}

.bom_btn {
  padding: 20px;
  // width: 50%;
  display: flex;
  justify-content: space-around;

  /deep/ .ivu-btn {
    padding: 0px 30px;
    margin: 0px 40px;
  }
}

.required::after {
  color: #ed4014;
  content: '*';
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-size: 14px;
}
</style>
